import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0da5d75d = () => interopDefault(import('../../../pages/accountless.vue' /* webpackChunkName: "pages/accountless" */))
const _3f80024f = () => interopDefault(import('../../../pages/activation.vue' /* webpackChunkName: "pages/activation" */))
const _f5a1f8c4 = () => interopDefault(import('../../../pages/book-demo.vue' /* webpackChunkName: "pages/book-demo" */))
const _6c755774 = () => interopDefault(import('../../../pages/document-type/index.vue' /* webpackChunkName: "pages/document-type/index" */))
const _08d23b40 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _40ba11c2 = () => interopDefault(import('../../../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _2d1fe995 = () => interopDefault(import('../../../pages/reset-password/index.vue' /* webpackChunkName: "pages/reset-password/index" */))
const _45cc6445 = () => interopDefault(import('../../../pages/training-room.vue' /* webpackChunkName: "pages/training-room" */))
const _d2cd0190 = () => interopDefault(import('../../../pages/document-type/create.vue' /* webpackChunkName: "pages/document-type/create" */))
const _56f82e46 = () => interopDefault(import('../../../pages/document-type/edit.vue' /* webpackChunkName: "pages/document-type/edit" */))
const _2609b490 = () => interopDefault(import('../../../pages/register/success.vue' /* webpackChunkName: "pages/register/success" */))
const _6833e1c3 = () => interopDefault(import('../../../pages/reset-password/confirm.vue' /* webpackChunkName: "pages/reset-password/confirm" */))
const _44aee90b = () => interopDefault(import('../../../pages/settings/billing/index.vue' /* webpackChunkName: "pages/settings/billing/index" */))
const _c40fee94 = () => interopDefault(import('../../../pages/settings/profile.vue' /* webpackChunkName: "pages/settings/profile" */))
const _4a53563b = () => interopDefault(import('../../../pages/settings/billing/details.vue' /* webpackChunkName: "pages/settings/billing/details" */))
const _07b9e280 = () => interopDefault(import('../../../pages/settings/billing/plan.vue' /* webpackChunkName: "pages/settings/billing/plan" */))
const _21cfb7ba = () => interopDefault(import('../../../pages/document-type/_document_type_id/models.vue' /* webpackChunkName: "pages/document-type/_document_type_id/models" */))
const _71f08840 = () => interopDefault(import('../../../pages/document-type/_document_type_id/model/_model_id/data-set-elements.vue' /* webpackChunkName: "pages/document-type/_document_type_id/model/_model_id/data-set-elements" */))
const _3f2a9829 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _791598b6 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accountless",
    component: _0da5d75d,
    name: "accountless"
  }, {
    path: "/activation",
    component: _3f80024f,
    name: "activation"
  }, {
    path: "/book-demo",
    component: _f5a1f8c4,
    name: "book-demo"
  }, {
    path: "/document-type",
    component: _6c755774,
    name: "document-type"
  }, {
    path: "/login",
    component: _08d23b40,
    name: "login"
  }, {
    path: "/register",
    component: _40ba11c2,
    name: "register"
  }, {
    path: "/reset-password",
    component: _2d1fe995,
    name: "reset-password"
  }, {
    path: "/training-room",
    component: _45cc6445,
    name: "training-room"
  }, {
    path: "/document-type/create",
    component: _d2cd0190,
    name: "document-type-create"
  }, {
    path: "/document-type/edit",
    component: _56f82e46,
    name: "document-type-edit"
  }, {
    path: "/register/success",
    component: _2609b490,
    name: "register-success"
  }, {
    path: "/reset-password/confirm",
    component: _6833e1c3,
    name: "reset-password-confirm"
  }, {
    path: "/settings/billing",
    component: _44aee90b,
    name: "settings-billing"
  }, {
    path: "/settings/profile",
    component: _c40fee94,
    name: "settings-profile"
  }, {
    path: "/settings/billing/details",
    component: _4a53563b,
    name: "settings-billing-details"
  }, {
    path: "/settings/billing/plan",
    component: _07b9e280,
    name: "settings-billing-plan"
  }, {
    path: "/document-type/:document_type_id?/models",
    component: _21cfb7ba,
    name: "document-type-document_type_id-models"
  }, {
    path: "/document-type/:document_type_id?/model/:model_id?/data-set-elements",
    component: _71f08840,
    name: "document-type-document_type_id-model-model_id-data-set-elements"
  }, {
    path: "/",
    component: _3f2a9829,
    name: "index"
  }, {
    path: "/*",
    component: _791598b6,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
